import React from "react";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { AxiosError, AxiosResponse } from "axios";
import { Field, InjectedFormProps, getFormValues, reduxForm } from "redux-form";
import FinSpinner from "../../../../../commonfields/FinSpinner";
import PricingField from "../PricingField";

interface ITieredPricingFormProps {
  handleSave: (values: FormData) => void;
  initialData?: object;
  pricingData:object;
}

const TieredPricingForm: React.FC<
  any & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const { handleSave, loader,pricingData,initialData,message,disableField } = props;

  return (
    <>
      {loader && <FinSpinner />}
      <form
        onSubmit={props.handleSubmit(handleSave)}
        className="tieredPricingForm"
      >
        {" "}
          <Row className="tiredPricing-row">
            {pricingData && pricingData.map((m:any,index:number)=>
            <Col md={6} key={`${m.name}-${index}`}>
              <Field
                component={PricingField}
                name={`${m.name}${m.rate}`}
                label={m.name}
                rate={m.rate}
                lock={m.lock}
                isRequired
                maxlength={60}
                disable={disableField}
              />
            </Col>
          )}
          </Row>
        <div className="buttonContainer">
          <Button className="nextButton">Next</Button>
        </div>
      </form>
    </>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: props.initialData,
    formValues: getFormValues("TieredPricingForm")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "TieredPricingForm", 
    enableReinitialize: true,
    touchOnChange: true,
  })(TieredPricingForm)
);
